import Vue from 'vue';
import common from './common';

window.RefAppMctb && Vue.use(window.RefAppMctb);
window.RefAppStoreLocator && Vue.use(window.RefAppStoreLocator);
window.RefAppBanner && Vue.use(window.RefAppBanner);
window.RefAppBeforeAfter && Vue.use(window.RefAppBeforeAfter);
// Add plugins
new Vue(common).$mount('#main-container');
